import { StorageKey } from "../../../../../cache/LocalCache"

import { readPerUserStorage, writePerUserStorage } from "./perUserStorage"

const parsePreference = (value: unknown): boolean | undefined => (typeof value === "boolean" ? value : undefined)

const readStoredPreferences = () => readPerUserStorage(StorageKey.CREATE_ORDER_TIMELINE_MEETING_FIT, parsePreference)

/** Whether the meeting narrowing starts on. Nothing saved means on, which is the long-standing default. */
export function loadMeetingFitPreference(userId: number): boolean {
    return readStoredPreferences()[String(userId)] ?? true
}

export function saveMeetingFitPreference(userId: number, isOn: boolean): void {
    const stored = readStoredPreferences()
    const userKey = String(userId)

    if ((stored[userKey] ?? true) === isOn) return

    if (isOn) {
        // No entry means "on", which is what an explicit `true` means too.
        delete stored[userKey]
    } else {
        stored[userKey] = false
    }

    writePerUserStorage(StorageKey.CREATE_ORDER_TIMELINE_MEETING_FIT, stored)
}
